import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import {
  ROLES,
  ROLES_CURRENT_ROLE,
  ROLES_SUPPLIER_ID,
  ROLES_RETAILER_ID,
  ROLES_CLEAR_PERMISSIONS,
  ROLES_RETAILER_SUPPLIERS,
  ROLES_SUPPLIER,
  ROLES_RETAILER,
  ROLES_USER,
  LOAD_USER_NOTIFICATIONS,
} from '../constants/rolesTypes';

const initialState = {
  roles: {
    suppliers: [],
    retailers: [],
    stores: [],
  },
  supplierId: undefined,
  retailerId: undefined,
  currentRole: undefined,
  retailerSuppliers: [],
  users: {},
  supplier: null,
  retailer: null,
  user: null,
  loadUserNotifications: false,
};

const suppliersNameById = (suppliers) => {
  return suppliers.reduce((names, { supplier }) => {
    names[supplier.id] = supplier.name;
    return names;
  }, {});
};

const role = (state = initialState, action) => {
  let userId;

  switch (action.type) {
    case ROLES_SUPPLIER:
      return {
        ...state,
        supplier: action.payload,
        retailer: null,
      };

    case ROLES_RETAILER:
      return {
        ...state,
        retailer: action.payload,
        supplier: null,
      };

    case ROLES_USER:
      return {
        ...state,
        user: action.payload,
      };

    case ROLES:
      return {
        ...state,
        roles: action.payload,
      };
    case ROLES_CURRENT_ROLE:
      userId = state.user.id;

      return {
        ...state,
        currentRole: action.payload,
        users: {
          ...state.users,
          [userId]: {
            ...state.users[userId],
            currentRole: action.payload,
          },
        },
      };

    case ROLES_SUPPLIER_ID:
      if (state.supplierId !== action.payload) {
        const supplierId = action.payload;
        userId = state.user.id;

        return {
          ...state,
          retailer: null,
          supplierId,
          suppliersNames: [],
          retailerSuppliers: [],
          users: {
            ...state.users,
            [userId]: {
              ...state.users[userId],
              supplierId,
            },
          },
        };
      }
      break;

    case ROLES_RETAILER_ID:
      if (state.retailerId !== action.payload) {
        const retailerId = action.payload;
        userId = state.user.id;

        return {
          ...state,
          supplier: null,
          retailerId,
          suppliersNames: [],
          retailerSuppliers: [],
          users: {
            ...state.users,
            [userId]: {
              ...state.users[userId],
              retailerId,
            },
          },
        };
      }
      break;

    case ROLES_CLEAR_PERMISSIONS:
      return {
        ...state,
        roles: {
          ...state.roles,
          suppliers: [],
          retailers: [],
          stores: [],
        },
        suppliersNames: [],
        retailerSuppliers: [],
        supplier: null,
        retailer: null,
        user: null,
      };
    case ROLES_RETAILER_SUPPLIERS:
      return {
        ...state,
        suppliersNames: suppliersNameById(action.payload),
        retailerSuppliers: action.payload,
      };
    case LOAD_USER_NOTIFICATIONS:
      return {
        ...state,
        loadUserNotifications: action.payload,
      };
    default:
      break;
  }
  return state;
};

const persistConfig = {
  key: 'role',
  storage: storage,
  blacklist: ['retailerSuppliers', 'suppliersNames'],
};

export default persistReducer(persistConfig, role);
